// index.js
import './text-decoder-polyfill'; // Step 1: Compilers guarantee this runs and finishes first

import { registerRootComponent } from 'expo';
import App from './App'; // Step 2: App (and pdfmake) compiles only AFTER step 1 is done

registerRootComponent(App);